let GridEvent = {
    initGrid:"InitGrid",
    selectChange:"SelectChange"
}

let FieldType = {
    "AttachFileField": "object",
    "BooleanField": "boolean",
    "ButtonField":"default",
    "ComputedObjectField":"object",
    "ContentPickerField":"object",
    "CorrelationField":"string",
    "DateField":"date",
    "DepartField":"object",
    "ImageField":"object",
    "MultChoiceProField":"object",
    "MultChoiceField":"object",
    "MultTextField":"string",
    "NumericField":"number",
    "PositionField":"object",
    "PrimaryKeyField":"string",
    "SignField":"object",
    "SingleChoiceProField":"string",
    "SingleChoiceField":"string",
    "SingleDepartField":"object",
    "SingleUserField":"object",
    "TextField":"string",
    "UserField":"object",
    "LinkContentItemField":"string"
}

let GridAction = {
    BatchCreate:"BatchCreate",
    BatchUpdate:"BatchUpdate",
    BatchPrint:"BatchPrint"
}

enum SingleAction {
    Print,
    OpenDrawer,
    RequestWorkFlow,
    CreateContent,
    UpdateContent,
    OpenGrid
}

export { GridEvent, FieldType,  GridAction, SingleAction}